import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "webform/store/store";

export const submitFormSliceSelector = (state: RootState) => state.submitForm;
export const submitFormLoadingSelector = createSelector(submitFormSliceSelector, ({isLoading}) => isLoading);
export const submitFormErrorSelector = createSelector(submitFormSliceSelector, ({error}) => error);
export const submitFormFieldsWithErrorSelector = createSelector(
    submitFormSliceSelector,
    ({fieldsWithError}) => fieldsWithError,
);
export const submitFormIsSubmittedSelector = createSelector(submitFormSliceSelector, ({isSubmitted}) => isSubmitted);
